module.exports = function (el) {
  var $el = $(el)

  var $label = $el.find('.label')

  var $ul = $el.find('ul')
  var $li = $el.find('ul li')

  $label.on('click', function (e) {
    e.preventDefault()
    $label.toggleClass('visible')
    $ul.toggleClass('visible')
  })

  $li.on('hover', function () {
    var itemClass = $(this).attr('class')
    $el.toggleClass('post-hover-' + itemClass)
  })
}
